import Image from '@/components/Image';
import TamaraModal from '@/components/modals/TamaraModal';
import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import userStore from '@/hooks/useStore';
import CurrencyIcon from '@/components/icons/CurrencyIcon';

const TamaraWidget = ({ total, locale }) => {
  const { t } = useTranslation('common');
  const store = userStore(locale);
  const minvalue = process.env.NEXT_PUBLIC_TAMARA_MIN_VALUE;
  const maxvalue = process.env.NEXT_PUBLIC_TAMARA_MAX_VALUE;
  const numberOfInstallments = process.env.NEXT_PUBLIC_TAMARA_INSTALLMENTS;
  const [show, setShow] = useState(false);

  return (
    total >= minvalue &&
    total <= maxvalue && (
      <>
        <div className='flex gap-2 p-2 bg-white border rounded-md sm:items-center'>
          <Image
            loading='lazy'
            src={`/svgs/tamara-${locale?.includes('en') ? 'en' : 'ar'}.svg`}
            className='object-contain w-10 h-7 sm:w-16'
            alt=''
          />
          <p className='flex flex-wrap items-center gap-1 text-xs leading-5 sm:text-[15px]'>
            {`${
              locale?.includes('en') ? 'Pay in' : 'ادفع على'
            } ${numberOfInstallments} ${
              locale?.includes('en')
                ? 'interest-free installments'
                : 'أقساط بدون فوائد'
            } `}
            <span className='flex items-center gap-1 font-bold whitespace-nowrap'>
              {(total / numberOfInstallments).toFixed(2)}{' '}
              {store !== 'ksa' ? (
                t('SAR')
              ) : (
                <CurrencyIcon className='size-3.5' />
              )}
              .
            </span>{' '}
            <button
              onClick={() => setShow(true)}
              className='font-semibold underline cursor-pointer text-zinc-500'
            >
              {locale?.includes('en') ? 'Find out' : 'إكتشف'}
            </button>
          </p>
        </div>
        <TamaraModal
          {...{ total, locale, show, setShow, numberOfInstallments }}
        />
      </>
    )
  );
};

export default TamaraWidget;
